module.exports = __webpack_public_path__ + "static/media/blue_background.9e56b6e9.png";